module.exports = __webpack_public_path__ + "2da7c1e9bf1b99addb2da0e188a46dc3.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/lot.svg
// module id = 882
// module chunks = 0